import { render } from "./topicPage.vue?vue&type=template&id=57f337b2&scoped=true"
import script from "./topicPage.vue?vue&type=script&lang=js"
export * from "./topicPage.vue?vue&type=script&lang=js"

import "./topicPage.vue?vue&type=style&index=0&id=57f337b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57f337b2"]])

export default __exports__